import React from 'react';
import { CheckCircle, X } from 'lucide-react';
import axios from 'axios';

const WithdrawalsTab = ({ 
  requests, 
  loading, 
  setLoading,
  language, 
  t,
  showSuccessToast,
  showErrorToast,
  loadData
}) => {
  const processWithdrawal = async (withdrawalId, status, notes = '') => {
    setLoading(true);
    try {
      await axios.post(`/api/payments/withdrawals/${withdrawalId}/process`, { status, notes });
      showSuccessToast(t('withdrawalProcessedSuccessfully', language, { status }));
      loadData();
    } catch (error) {
      showErrorToast(error.response?.data?.message || t('failedToProcessWithdrawal', language));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tournament-section">
      <h4 className="tournament-section-title">{t('withdrawalRequests', language)}</h4>
      {requests.length === 0 ? (
        <div className="tournament-empty">
          <p className="tournament-empty-text">{t('noPendingRequests', language)}</p>
        </div>
      ) : (
        requests.map(request => (
          <div key={request._id} className="tournament-item orange">
            <div className="tournament-header">
              <div className="tournament-info">
                <p className="tournament-title">{request.user.inGameName}</p>
                <p className="tournament-details">
                  <strong>{t('accountEmail', language) || 'Account'}:</strong> {request.user.email}
                </p>
                <p className="tournament-details">
                  <strong>{t('paypalEmail', language) || 'PayPal'}:</strong> {request.paypalEmail || request.user.email}
                </p>
                <p className="tournament-details">
                  {request.points} {t('points', language)} → ${request.amount.toFixed(2)}
                </p>
                <p className="tournament-details">{new Date(request.createdAt).toLocaleString()}</p>
              </div>
              <div className="tournament-actions">
                <button 
                  onClick={() => processWithdrawal(request._id, 'approved')} 
                  disabled={loading}
                  className="btn-compact btn-success"
                >
                  <CheckCircle className="w-4 h-4" />
                  {t('approve', language)}
                </button>
                <button 
                  onClick={() => processWithdrawal(request._id, 'rejected')} 
                  disabled={loading}
                  className="btn-compact btn-danger"
                >
                  <X className="w-4 h-4" />
                  {t('reject', language)}
                </button>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default WithdrawalsTab;